import { render, staticRenderFns } from "./ForumThreadPageAside.vue?vue&type=template&id=6e6701c4&scoped=true"
import script from "./ForumThreadPageAside.vue?vue&type=script&lang=js"
export * from "./ForumThreadPageAside.vue?vue&type=script&lang=js"
import style0 from "./ForumThreadPageAside.vue?vue&type=style&index=0&id=6e6701c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6701c4",
  null
  
)

export default component.exports